module.exports = __webpack_public_path__ + "static/media/rate-down.d6ef13ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rate-down.svg
// module id = 893
// module chunks = 7